import { useLazyQuery, useMutation } from "@apollo/client";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import { Spinner } from "react-bootstrap";
import {
  COLOR_TEXT,
  LOGISTICS_DATAS,
  RemoveFields,
  S3_URL,
} from "../../../constants";
import { GET_BANKS } from "../../../graphql/bank/query";
import {
  calcOrderTotal,
  formatDeliveryAddress,
  imageRender,
  numberFormat,
} from "../../../helpers";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import _ from "lodash";
import { faCopy, faFileArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { GET_PRESIGN_URL } from "../../../graphql/presignUrl/query";
import {
  CONFIRM_ORDER_GROUP,
  UPDATE_ORDERGROUP,
} from "../../../graphql/order/mutation";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";
import { FaDownload } from "react-icons/fa";
import { saveAs } from "file-saver";
import FindAddressByPhone from "./FindAddressByPhone";
import FormReceiveAddress from "../../settings/settingLogictics/settingReceive/FormReceiveAddress";
import { GET_USER_ADDRESS_BY_PHONE } from "../../../graphql/userConfirm/userAddress/query";
import { ADD_ORDER_DELIVERY } from "../../../graphql/orderDelivery/mutation";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {
  errorFields,
  requestionFields,
  successFields,
} from "../../../helpers/sweetalert";

// ຟອມຮຽກ onCloseModalAdd ຫຼັງບັນທຶກ — ດຽວນີ້ບໍ່ມີໜ້າຕ່າງໃຫ້ປິດ ຈຶ່ງບໍ່ຕ້ອງເຮັດຫຍັງ
// ປະກາດໄວ້ນອກ component ຈະໄດ້ບໍ່ສ້າງ function ໃໝ່ທຸກຮອບ render
const noop = () => {};

const ShopInfoOrderConfirm = ({
  orderData,
  setLastStep,
  // setSecondStep,
  // shopSettingData,
  // bankData,
  isUseLogicstics,
  setIsUseLogicstics,
  setIsuse,
  isAlert,
  setIsAlert,
  setIsShipMentPayType,
  isShipMentPayType,
  settingDataByShop,
  shopRate,
  taxPrice,
  selectedDelivery,
}) => {
  const [getPresignUrl] = useLazyQuery(GET_PRESIGN_URL);
  const [getUserConfirms, { data: userConfirmDatas }] =
    useLazyQuery(GET_USER_CONFIRMS);
  const [loadBankAccount, { data: bankAccountData }] = useLazyQuery(GET_BANKS, {
    fetchPolicy: "cache-and-network",
  });

  // const [updateOrderGroup, { loading: updateOrderGroupLoading }] = useMutation(UPDATE_ORDERGROUP);
  const [confirmOrderGroup, { loading: confirmOrderGroupLoading }] =
    useMutation(CONFIRM_ORDER_GROUP);

  // State
  // const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState({});
  const [file, setFile] = useState();
  const [paySlip, setPaySlip] = useState();
  const [address, setAddress] = useState("");
  // ຊ່ອງພິມເບີຢູ່ໃນ FindAddressByPhone ແລ້ວ ໜ້ານີ້ເປັນຄົນຖືຄ່າໄວ້ໃຫ້ຕອນຢືນຢັນອໍເດີ
  // (ການກວດ 7-11 ຕົວຍັງເຮັດຢູ່ໃນ _updateOrderGroup ຄືເກົ່າ)
  const [phone, setPhone] = useState("");

  const [payMethod, setPayMethod] = useState("TRANSFER");

  // ໃຊ້ helper ອັນດຽວກັບໃບສະຫຼຸບ ຕົວເລກສອງບ່ອນຈຶ່ງກົງກັນສະເໝີ
  const orderTotal = useMemo(
    () => calcOrderTotal({ orderData, taxPrice, shopRate }),
    [orderData, taxPrice, shopRate],
  );
  // ກົດ "ພິມທີ່ຢູ່ເອງ" ຈາກໃນຟອມ — ສະຫຼັບໂໝດຢູ່ໜ້ານີ້ເລີຍ
  const onUseManualAddress = useCallback(() => {
    setIsUseLogicstics("NOT_USE_LOGICSTIC");
  }, [setIsUseLogicstics]);
  const [customerName, setCustomerName] = useState("");
  // const [bankQr, setBankQr] = useState();
  const [defaultBank, setDefaultBank] = useState();
  const [bankAccountLists, setBankAccountLists] = useState([]);

  useEffect(() => {
    if (orderData) {
      setCustomerName(orderData?.customerName || orderData?.cfName);
      setAddress(`${orderData?.logistic || ""} ${orderData?.addressCf || ""}`);
      if (orderData?.phone !== "" && orderData?.phone !== "-")
        setPhone(orderData?.phone);

      if (!_.isEmpty(orderData?.userFbId)) {
        getUserConfirms({
          variables: {
            where: {
              psid: orderData?.userFbId,
              // name: orderData?.cfName
            },
            orderBy: "createdAt_DESC",
          },
        });
      }

      loadBankAccount({
        variables: {
          where: {
            shop: orderData?.shop?.id,
            isDeleted: false,
          },
        },
      });
    }
  }, [orderData]);

  useEffect(() => {
    if (bankAccountData) {
      setBankAccountLists(bankAccountData?.banks?.data);
      const _bankActive = bankAccountData?.banks?.data.find(
        (data) => data?.isActiveDefault || data[0],
      );

      if (_bankActive) {
        setSelectedBank(_bankActive);
      }
    }
  }, [bankAccountData]);

  useEffect(() => {
    if (userConfirmDatas?.userConfirms?.data?.length > 0) {
      const firstConfirm = userConfirmDatas.userConfirms.data[0];
      if (
        firstConfirm?.phone &&
        (!orderData?.phone || orderData?.phone === "-")
      ) {
        setPhone(firstConfirm.phone);
      }
      if (
        firstConfirm?.addressCF &&
        (!orderData?.addressCf || orderData?.addressCf === "-")
      ) {
        setAddress(firstConfirm.addressCF);
      }
    }
  }, [userConfirmDatas, orderData]);

  // useEffect(() => {
  //   if (shopSettingData?.settings?.data) {
  //     setBankQr(shopSettingData?.settings?.data[0]?.bankQr);
  //     let _bank = JSON.parse(shopSettingData?.settings?.data[0]?.bank);
  //     setDefaultBank(_bank);
  //   }

  //   if (bankData?.banks) {
  //     // filter active bank
  //     const _bankActive = bankData?.banks?.data.find((data) => data?.isActiveDefault); // Using `find` to get the first matching bank

  //     if (_bankActive) {
  //       setSelectedBank(_bankActive); // Set the selected bank
  //     } else {
  //       setSelectedBank(bankData?.banks?.data[0]); // Set the selected bank

  //     }
  //     setBanks(bankData?.banks?.data); // Set all banks
  //   }
  // }, [bankData, shopSettingData]);

  // ກຳລັງອັບຮູບຂຶ້ນ S3 ຢູ່ບໍ — ໃຊ້ບອກສະຖານະໃນກ່ອງອັບໂຫຼດ
  const [isUploadingSlip, setIsUploadingSlip] = useState(false);

  // ດາວໂຫຼດຮູບ QR ລົງເຄື່ອງ — S3 ເປີດ CORS ໄວ້ ຈຶ່ງດຶງເປັນ blob ໄດ້
  // ແຕ່ webview ຂອງ Facebook ບາງເຄື່ອງບລັອກການບັນທຶກໄຟລ໌ ຈຶ່ງມີທາງສຳຮອງເປີດຮູບໃຫ້ກົດຄ້າງເອົາ
  const [isDownloadingQr, setIsDownloadingQr] = useState(false);
  const onDownloadQr = async () => {
    const _url = imageRender(selectedBank?.image);
    if (!_url || isDownloadingQr) return;
    try {
      setIsDownloadingQr(true);
      const res = await fetch(_url);
      if (!res.ok) throw new Error("FETCH_FAILED");
      const blob = await res.blob();
      // S3 ສົ່ງ Content-Type ມາເປັນ "file/*; image/*" ເຊິ່ງບໍ່ຖືກຮູບແບບ
      // ຖ້າອີງຕາມນັ້ນ ຊື່ໄຟລ໌ຈະພັງ ແລະ ມືຖືຈະບໍ່ຮູ້ວ່າເປັນຮູບ — ຈຶ່ງອ່ານນາມສະກຸນຈາກ URL ແທນ
      const _raw = (_url.split("?")[0].split(".").pop() || "").toLowerCase();
      const _ext = /^(jpg|jpeg|png|webp)$/.test(_raw) ? _raw : "jpg";
      const _mime =
        _ext === "jpg" || _ext === "jpeg" ? "image/jpeg" : `image/${_ext}`;
      saveAs(
        new Blob([blob], { type: _mime }),
        `QR-${selectedBank?.bankName || "bank"}.${_ext}`,
      );
    } catch (error) {
      window.open(_url, "_blank", "noopener");
    } finally {
      setIsDownloadingQr(false);
    }
  };

  const onCopy = (bankAccount) => {
    navigator.clipboard.writeText(bankAccount ?? "");
    successFields({ text: "ສຳເນົາເລກບັນຊີແລ້ວ" });
  };

  // ອັບຮູບຂຶ້ນ S3 ທັນທີຕອນເລືອກໄຟລ໌ — ຕັ້ງ paySlip ຫຼັງອັບສຳເລັດເທົ່ານັ້ນ
  // ເມື່ອກົດ "ຢືນຢັນການຊຳລະ" ຈຶ່ງບໍ່ຕ້ອງລໍຖ້າຮູບອີກ
  const handleUpload = async (event) => {
    const _file = event.target.files?.[0];
    if (!_file || isUploadingSlip) return;

    const _ext = _file.name.split(".").pop();
    const _filename = uuidv4() + "." + _ext;

    setIsUploadingSlip(true);
    try {
      const _res = await getPresignUrl({ variables: { name: _filename } });
      const _url = _res?.data?.preSignedUrl?.url;
      if (!_url) throw new Error("PRESIGN_URL_NOT_FOUND");

      await axios.put(_url, _file, {
        headers: {
          "Content-Type": "file/*; image/*",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
          "Access-Control-Allow-Headers":
            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
        },
      });
      // ສະແດງຮູບຫຼັງອັບຂຶ້ນ S3 ສຳເລັດແລ້ວເທົ່ານັ້ນ
      setFile(_file);
      setPaySlip(_filename);
    } catch (error) {
      console.log("ERROR: ", error);
      setPaySlip(null);
      setFile(null);
      requestionFields({
        text: "ກະລຸນາອັບໂຫຼດສະລີບໂອນເງິນຄືນຫມ່ອີກຄັ້ງ",
      });
    } finally {
      setIsUploadingSlip(false);
    }
  };

  const ImageThumb = ({ image }) => {
    return (
      <img
        className="cf-upload__preview"
        src={URL.createObjectURL(image)}
        alt={image.name}
      />
    );
  };

  //! FIND ADDRESS BY PHONE (ແທນລະບົບ PIN ເກົ່າ)
  const [idDataUserConfirm, setIdDataUserConfirm] = useState({});
  const [phoneAddresses, setPhoneAddresses] = useState([]);
  const [lookupPhone, setLookupPhone] = useState("");

  //! RECEIVE ADDRESS
  const [isReceiveData, setIsReceiveData] = useState({});
  // ຟອມທີ່ຢູ່ຝັງຢູ່ໃນໜ້າເລີຍ ບໍ່ໄດ້ຢູ່ໃນໜ້າຕ່າງແຍກອີກແລ້ວ
  const [userAddressByPhone_API] = useLazyQuery(GET_USER_ADDRESS_BY_PHONE, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (!_.isEmpty(isReceiveData)) {
      if (isReceiveData?.userName) {
        setCustomerName(isReceiveData?.userName);
      }
      // ທີ່ຢູ່ທີ່ລູກຄ້າໃຫ້ໄວ້ໃນແຊັດ (orderData.addressCf) ຊະນະທີ່ຢູ່ລ່າສຸດຂອງເບີສະເໝີ
      // ເມື່ອກ່ອນພໍຄົ້ນເບີພົບ ທີ່ຢູ່ເກົ່າຂອງເບີນັ້ນຈະທັບທີ່ຢູ່ຈາກແຊັດຖິ້ມ
      // ທີ່ຢູ່ຕາມເບີໃຊ້ສະເພາະຕອນທີ່ແຊັດບໍ່ໄດ້ໃຫ້ທີ່ຢູ່ມາ
      const _chatAddress = String(orderData?.addressCf ?? "").trim();
      if (!_chatAddress || _chatAddress === "-") {
        setAddress(formatDeliveryAddress(isReceiveData));
      }
      if (isReceiveData?.userTel) {
        setPhone(isReceiveData?.userTel);
      }
    }
  }, [isReceiveData]);

  /**
   * ເມື່ອກ່ອນລ໋ອກປຸ່ມຢືນຢັນໄວ້ຈົນກວ່າຈະກົດ "ບັນທຶກທີ່ຢູ່" ໃນຟອມ
   *
   * ດຽວນີ້ຟອມບໍ່ມີປຸ່ມບັນທຶກແລ້ວ — ປຸ່ມຢືນຢັນເປັນຄົນສັ່ງບັນທຶກເອງ
   * ຖ້າຍັງລ໋ອກໄວ້ຈະກົດບໍ່ໄດ້ຕະຫຼອດການ ເພາະ isReceiveData ຈະບໍ່ມີວັນມີຄ່າ
   *
   * ຄວາມຄົບຖ້ວນຂອງທີ່ຢູ່ ຟອມກວດເອງດ້ວຍ Yup ແລ້ວສະແດງ error ໃຫ້ເຫັນ
   */
  const isWaitingReceiveAddress = false;

  // ໃຫ້ປຸ່ມຢືນຢັນສັ່ງຟອມບັນທຶກທີ່ຢູ່ໄດ້
  const saveAddressRef = useRef(null);

  /**
   * COD ໃຊ້ໄດ້ເມື່ອຄົບ 3 ຢ່າງ:
   *   1. ຮ້ານເປີດ COD ໄວ້
   *   2. ລູກຄ້າຢູ່ໂໝດໃຊ້ຂົນສົ່ງໃນລະບົບ
   *   3. ເລືອກທີ່ຢູ່/ຂົນສົ່ງແລ້ວ  ← ຂໍ້ນີ້ເພີ່ມມາໃໝ່
   *
   * ຂໍ້ 3 ຈຳເປັນ ເພາະ COD ຕ້ອງບຸກຂົນສົ່ງຈິງ ຖ້າຍັງບໍ່ມີທີ່ຢູ່ ກົດໄປກໍ່ລົ້ມຢູ່ດີ
   *
   * ຢູ່ລຸ່ມ isReceiveData ເພາະ const ອ່ານກ່ອນປະກາດບໍ່ໄດ້ (TDZ)
   * ຍ້າຍຂຶ້ນໄປໄວ້ເທິງຄືເກົ່າຈະ ReferenceError ທັນທີ
   */
  const isCodAvailable =
    settingDataByShop?.settingByShopId?.logisticsCOD &&
    isUseLogicstics === "IS_USE_LOGICSTIC" &&
    !_.isEmpty(isReceiveData);

  // COD ຫາຍໄປແລ້ວແຕ່ຄ້າງຢູ່ແທັບ COD = ຕິດຢູ່ໂໝດທີ່ບໍ່ມີແທັບໃຫ້ກົດກັບ
  // (ເຊັ່ນ: ເລືອກ COD ໄວ້ ແລ້ວສະຫຼັບໄປພິມທີ່ຢູ່ເອງ) ດຶງກັບມາໂອນເງິນໃຫ້ເອງ
  useEffect(() => {
    if (!isCodAvailable && payMethod === "COD") setPayMethod("TRANSFER");
  }, [isCodAvailable, payMethod]);

  // ດຶງລາຍການໃໝ່ຫຼັງລູກຄ້າເພີ່ມທີ່ຢູ່ ເພື່ອໃຫ້ທີ່ຢູ່ທີ່ຫາກໍ່ບັນທຶກຂຶ້ນມາທັນທີ
  // ຟອມສົ່ງເບີທີ່ຫາກໍ່ບັນທຶກມາໃຫ້ ເພາະໜ້ານີ້ບໍ່ໄດ້ຜ່ານຂັ້ນຕອນຄົ້ນເບີຈຶ່ງບໍ່ຮູ້ເບີມາກ່ອນ
  const refetchAddressByPhone = async (phoneFromForm) => {
    try {
      const _phone = phoneFromForm || lookupPhone;
      if (_phone?.length !== 8) return;
      setLookupPhone(_phone);
      const res = await userAddressByPhone_API({
        variables: { where: { userTel: _phone } },
      });
      const _list = res?.data?.userAddressByPhone?.data ?? [];
      setPhoneAddresses(_list);
      // ທີ່ຢູ່ທີ່ເລືອກໄວ້ອາດຖືກລຶບໄປ — ຖ້າບໍ່ລ້າງ ຈະຢືນຢັນອໍເດີໃສ່ record ທີ່ບໍ່ມີແລ້ວ
      //
      // ເມື່ອກ່ອນລ້າງເປັນ {} ແລ້ວປະໃຫ້ CardDefaultReceiveAddress ເລືອກອັນ default ໃໝ່ໃຫ້
      // ດຽວນີ້ບໍ່ມີ card ນັ້ນແລ້ວ (ໃຊ້ຟອມໂດຍກົງ) ຈຶ່ງບໍ່ມີໃຜເລືອກໃຫ້
      // ຖ້າປະໄວ້ເປັນ {} ປຸ່ມຢືນຢັນຈະຖືກລ໋ອກຄ້າງ ທັງທີ່ຫາກໍບັນທຶກທີ່ຢູ່ສຳເລັດ
      // backend ຮຽງ updatedAt DESC ມາໃຫ້ — _list[0] ຈຶ່ງແມ່ນອັນທີ່ຫາກໍບັນທຶກ
      setIsReceiveData(
        (prev) => _list.find((item) => item?.id === prev?.id) || _list[0] || {},
      );
      const _userId = res?.data?.userAddressByPhone?.userId;
      if (_userId) setIdDataUserConfirm({ id: _userId, phone: _phone });

      // ຄືນລາຍການໃຫ້ຜູ້ເອີ້ນນຳ — ຟອມຕ້ອງການ record ເຕັມຂອງທີ່ຢູ່ທີ່ຫາກໍບັນທຶກ
      // ອ່ານຈາກ state ບໍ່ໄດ້ ເພາະ setIsReceiveData ຍັງບໍ່ທັນມີຜົນໃນ tick ດຽວກັນ
      return _list;
    } catch (err) {
      console.log("ERROR_refetchAddressByPhone");
      return [];
    }
  };

  /**
   * ທີ່ຢູ່ລ່າສຸດຂອງເບີນີ້ — ໃຊ້ເປັນຄ່າຕັ້ງຕົ້ນຂອງຟອມ (ແຂວງ / ເມືອງ / ສາຂາ)
   *
   * ເອົາອັນທີ່ເລືອກຄ້າງໄວ້ກ່ອນ ຖ້າຍັງບໍ່ໄດ້ເລືອກຄ່ອຍເອົາໃບເທິງສຸດ
   * (backend ຮຽງ updatedAt DESC ມາໃຫ້ = ໃບທີ່ໃຊ້ລ່າສຸດ)
   *
   * ມີ id ຕິດໄປນຳ ໝາຍຄວາມວ່າກົດບັນທຶກຈະເປັນການ "ແກ້ໄຂ" ໃບເກົ່າ ບໍ່ແມ່ນສ້າງໃບໃໝ່
   * ຕັ້ງໃຈແບບນັ້ນ — ບໍ່ດັ່ງນັ້ນລູກຄ້າຄົນດຽວຈະມີທີ່ຢູ່ຊ້ຳກັນເປັນສິບໃບ
   */
  const lastAddressByPhone = useMemo(() => {
    if (!_.isEmpty(isReceiveData)) return isReceiveData;
    return phoneAddresses?.[0];
  }, [isReceiveData, phoneAddresses]);

  // ຜົນຄົ້ນຫາຈາກຊ່ອງເບີໂທ: ເລືອກທີ່ຢູ່ໃໝ່ສຸດໃຫ້ເລີຍ ລູກຄ້າກົດຕໍ່ໄປໄດ້ໂດຍບໍ່ຕ້ອງເລືອກຫຍັງ
  // ບໍ່ສ້າງບັນຊີໃຫ້ຕັ້ງແຕ່ຕອນນີ້ ເພາະຄົ້ນອັດຕະໂນມັດທຸກເບີ 8 ຕົວ ພິມຜິດເທື່ອດຽວກໍ່ຈະໄດ້
  // record ຂີ້ເຫຍື້ອ — ປະໃຫ້ FormReceiveAddress ສ້າງເອງຕອນກົດບັນທຶກຈິງ
  const onFoundAddressByPhone = ({ phone: foundPhone, userId, addresses }) => {
    setLookupPhone(foundPhone);
    setPhoneAddresses(addresses);
    setIsReceiveData(addresses[0] ?? {});
    setIdDataUserConfirm(
      userId ? { id: userId, phone: foundPhone } : { phone: foundPhone },
    );
  };

  //! ADD_USER_ADDRESS
  const [addOrderDelivery_API, { loading: addOrderDeliveryLoading }] =
    useMutation(ADD_ORDER_DELIVERY);
  // ຮັບທີ່ຢູ່ເປັນ argument ບໍ່ອ່ານຈາກ state — ຕອນກົດຢືນຢັນ ທີ່ຢູ່ຫາກໍ່ຖືກບັນທຶກ
  // ໃນ tick ດຽວກັນ state ຍັງເປັນຄ່າເກົ່າຢູ່
  const addOrderDeliveryWeb = async (_dataShipMentPay, _receive) => {
    try {
      const isReceiveData = _receive;
      let _data = {
        // shipment_pay_type: orderData?.orders[0]?.stock?.shipment_pay_type ?? "CDC",
        shipment_pay_type: !_.isEmpty(_dataShipMentPay) ? "COD" : "CDC",
        latLong: isReceiveData?.latLong,
        sender: isReceiveData?.sender,
      };

      const newAddOrderDelivery_API = await addOrderDelivery_API({
        variables: {
          data: _data,
          where: {
            delivery: isReceiveData?.deliveryName,
            orderGroupId: orderData?.id,
            userAddressId: isReceiveData?.id,
            shop: orderData?.shop?.id,
          },
        },
        /**
         * keepalive ໃຫ້ request ນີ້ແລ່ນຕໍ່ໄດ້ເຖິງໜ້າຈະ reload ໄປແລ້ວ
         *
         * ການຈອງຂົນສົ່ງຕ້ອງລໍ API ຂອງ J&T/HAL/MIXAY ຕອບ (ວັດໄດ້ 1-12 ວິນາທີ)
         * ຖ້າລໍໃຫ້ຈົບກ່ອນ ລູກຄ້າຈະຄ້າງຢູ່ໜ້າຈ່າຍເງິນທັງໆທີ່ຈ່າຍສຳເລັດແລ້ວ
         *
         * ບໍ່ໃສ່ keepalive ແລ້ວຍິງແບບບໍ່ລໍ = ຖືກ browser ຕັດຖິ້ມຕອນ reload
         * ຜົນຄື ອໍເດີຢືນຢັນແລ້ວແຕ່ບໍ່ມີບິນຂົນສົ່ງ
         */
        context: { fetchOptions: { keepalive: true } },
      });
      if (
        newAddOrderDelivery_API?.data?.addOrderDelivery?.message !== "Success"
      )
        throw newAddOrderDelivery_API?.data?.addOrderDelivery?.message;
      return { isError: false };
    } catch (err) {
      // ບໍ່ເດັ້ງ popup ແລ້ວ — ຕອນນີ້ຍິງແບບບໍ່ລໍ ໜ້າອາດ reload ໄປກ່ອນ popup ຈະຂຶ້ນ
      // ແລະ ຖ້າຂຶ້ນທັນກໍ່ຈະໄປບັງຂໍ້ຄວາມ "ບັນທຶກສຳເລັດ" ຂອງການຢືນຢັນ
      console.log("ERROR_addOrderDeliveryWeb");
      return { isError: true };
    }
  };

  useEffect(() => {
    if (isShipMentPayType?.data) {
      _updateOrderGroup(isShipMentPayType?.data);
    }
  }, [isShipMentPayType?.data]);

  //TODO Confirm order
  const _updateOrderGroup = async (dataShipMentPay) => {
    try {
      // if (updateOrderGroupLoading) return;
      if (confirmOrderGroupLoading) return;

      if (_.isEmpty(customerName)) {
        return requestionFields({
          text: "ກະລຸນາປ້ອນຊື່ກ່ອນ",
        });
      }
      if (_.isEmpty(phone)) {
        return requestionFields({
          text: "ກະລຸນາປ້ອນເບີໂທກ່ອນ",
        });
      }
      if (phone.length < 7 || phone.length > 11) {
        return requestionFields({
          text: "ກະລຸນາປ້ອນເບີໂທ 7-8 ໂຕເລກ ໂດຍບໍ່ຕ້ອງໃສ່ 020 ຂື້ນຕົ້ນ",
        });
      }

      /**
       * ໂໝດໃຊ້ຂົນສົ່ງ: ບັນທຶກທີ່ຢູ່ກ່ອນ ແລ້ວຄ່ອຍໄປຕໍ່
       *
       * ຟອມບໍ່ມີປຸ່ມບັນທຶກຂອງຕົນເອງແລ້ວ ປຸ່ມນີ້ເປັນຄົນສັ່ງ
       * ແລະ ຕ້ອງບັນທຶກໃຫ້ໄດ້ id ກ່ອນ ເພາະ addOrderDelivery ຂອງ backend
       * ບັງຄັບ USER_ADDRESS_ID_IS_REQUIRED
       *
       * ຟອມ validate ແລະ ສະແດງ error ຂອງມັນເອງ ຖ້າ isError ກໍ່ຢຸດຢູ່ນີ້ເລີຍ
       */
      let _receiveData = isReceiveData;
      let _addressText = address;
      if (isUseLogicstics === "IS_USE_LOGICSTIC") {
        const _save = saveAddressRef.current;
        const _saved = _save ? await _save() : null;
        if (!_saved || _saved.isError || !_saved.data?.id) return;

        _receiveData = _saved.data;
        _addressText = formatDeliveryAddress(_saved.data);
        setIsReceiveData(_saved.data);
        setAddress(_addressText);
      }

      if (
        _addressText === "" ||
        _addressText === null ||
        _addressText === undefined ||
        _addressText === " "
      ) {
        return requestionFields({
          text: "ກະລຸນາປ້ອນທີ່ຢູ່ກ່ອນ",
        });
      }
      if (_.isEmpty(dataShipMentPay)) {
        if (_.isEmpty(paySlip)) {
          return requestionFields({
            text: isUploadingSlip
              ? "ກຳລັງບັນທຶກຮູບສະລີບ ກະລຸນາລໍຖ້າຄາວໜຶ່ງ"
              : "ກະລຸນາອັບໂຫຼດສະລີບໂອນເງິນກ່ອນ",
          });
        }
      }

      let _dataOrderGroup = {
        paySlip: paySlip,
        customerName: customerName,
        phone: phone,
        addressCf: _addressText,
        isPaymented: true,
        paymentType: "DESTINATION",
        payment: "TRANSFER",
        bank: selectedBank?.id,
        status: "WAITINGCONFIRM",
        paymentMethod: "MANNUALY",
      };

      // ລູກຄ້າເລືອກຂົນສົ່ງຈາກ dropdown ດ້ານເທິງ → ຂຽນຊື່ລົງ `logistic` ຂອງ orderGroup
      // ຮ້ານຈຶ່ງເຫັນຢູ່ຊ່ອງ "ຂົນສົ່ງ" ໃນໜ້າ OrderAddV2 ໂດຍບໍ່ຕ້ອງພິມເອງ
      // ເລືອກ "ຂົນສົ່ງອື່ນໆ" (selectedDelivery ວ່າງ) ບໍ່ແຕະ ປະໃຫ້ຮ້ານພິມເອງຄືເກົ່າ
      // ຂົນສົ່ງມາຈາກທີ່ຢູ່ທີ່ລູກຄ້າເລືອກ (ບໍ່ໄດ້ເລືອກແຍກຢູ່ໜ້າຫຼັກອີກແລ້ວ)
      //
      // ໂໝດພິມທີ່ຢູ່ເອງຕ້ອງບໍ່ຂຽນຊື່ຂົນສົ່ງລົງໄປ
      //
      // ຕອນສະຫຼັບໄປພິມເອງ ເຮົາບໍ່ໄດ້ລ້າງ isReceiveData ຖິ້ມ (ຕັ້ງໃຈ — ຊື່/ເບີ prefill ມາຈາກມັນ)
      // ຖ້າບໍ່ກັນໄວ້ ຂົນສົ່ງຂອງທີ່ຢູ່ເກົ່າຈະຖືກຂຽນລົງ logistic ຢູ່ດີ
      // ຜົນຄື ຮ້ານເຫັນ "J&T Express" ທັງທີ່ລູກຄ້າພິມທີ່ຢູ່ເອງ
      const _carrierKey =
        isUseLogicstics === "IS_USE_LOGICSTIC"
          ? _receiveData?.deliveryName || selectedDelivery
          : "";
      if (!_.isEmpty(_carrierKey)) {
        _dataOrderGroup = {
          ..._dataOrderGroup,
          logistic:
            LOGISTICS_DATAS?.[_carrierKey.toLowerCase()]?.name || _carrierKey,
        };
      } else if (isUseLogicstics !== "IS_USE_LOGICSTIC") {
        // ບອກຮ້ານໃຫ້ຊັດວ່າອໍເດີນີ້ບໍ່ມີຂົນສົ່ງໃນລະບົບ ຕ້ອງຈັດການເອງ
        // ປະຫວ່າງໄວ້ ຊ່ອງ "ຂົນສົ່ງ" ຂອງຮ້ານຈະບອດ ບອກຫຍັງບໍ່ໄດ້ເລີຍ
        // ຕາຕະລາງຝັ່ງຮ້ານຫາໄອຄອນຈາກ LOGISTICS ບໍ່ພົບກໍຕົກໄປ noPhoto.png ບໍ່ພັງ
        _dataOrderGroup = { ..._dataOrderGroup, logistic: "ພິມທີ່ຢູ່ເອງ" };
      }

      if (orderData.sumPriceBaht > 0 || orderData.sumPriceUsd > 0) {
        const newRate = RemoveFields(shopRate, ["__typename"]);
        _dataOrderGroup = {
          ..._dataOrderGroup,
          rate: JSON.stringify(newRate),
        };
      }

      if (!_.isEmpty(dataShipMentPay)) {
        _dataOrderGroup = {
          ..._dataOrderGroup,
          dataConfirmCod: JSON.stringify(dataShipMentPay),
        };
      }

      // const res = await updateOrderGroup({
      //   variables: {
      //     data: _dataOrderGroup,
      //     where: {
      //       id: orderData?.id,
      //     },
      //   },
      // });
      // if (res) {
      //   setLastStep(true);
      //   addToast("ບັນທຶກສໍາເລັດ", {
      //     appearance: "success",
      //     autoDismiss: true,
      //   });
      //   window.location.reload();
      // }
      /**
       * ຈອງຂົນສົ່ງ ກັບ ຢືນຢັນອໍເດີ ຍິງພ້ອມກັນ
       *
       * ເມື່ອກ່ອນລໍຈອງຂົນສົ່ງໃຫ້ຈົບກ່ອນ ຄ່ອຍຢືນຢັນ — ລູກຄ້າຕ້ອງລໍ 2 ຮອບຕໍ່ກັນ
       * ແລະ ຮອບຈອງຂົນສົ່ງແມ່ນຊ້າສຸດ ເພາະຕ້ອງລໍ API ຂອງ J&T/HAL/MIXAY ຕອບ
       *
       * ສອງອັນນີ້ບໍ່ໄດ້ຂຶ້ນຕໍ່ກັນ — _dataOrderGroup ຄິດຈາກ _receiveData ທີ່ມີແລ້ວ
       * ບໍ່ໄດ້ໃຊ້ຜົນຂອງການຈອງ ຈຶ່ງຍິງພ້ອມກັນໄດ້ ເສຍເວລາເທົ່າອັນທີ່ຊ້າສຸດແທນຜົນລວມ
       *
       * ຈອງລົ້ມເຫຼວຕ້ອງບໍ່ຍົກເລີກການຢືນຢັນ (ຄືກັນກັບ MultiStepForm) — ຖ້າ throw
       * ອອກໄປ ລູກຄ້າຈ່າຍເງິນແລ້ວແຕ່ອໍເດີບໍ່ຖືກຢືນຢັນ ຈຶ່ງດັກ error ໄວ້ບໍ່ໃຫ້ລົ້ນ
       */
      // ຍິງໄປແລ້ວບໍ່ລໍ — ບໍ່ໄດ້ຢູ່ໃນເສັ້ນທາງທີ່ລູກຄ້າຕ້ອງລໍອີກຕໍ່ໄປ
      // .catch ຕ້ອງມີ ບໍ່ດັ່ງນັ້ນຈະເປັນ unhandled rejection ຕອນຈອງລົ້ມ
      if (isUseLogicstics === "IS_USE_LOGICSTIC") {
        addOrderDeliveryWeb(dataShipMentPay, _receiveData).catch(() => {
          console.log("DELIVERY_BOOKING_FAILED_CONTINUING_TO_CONFIRM");
        });
      }

      const resConfirm = await confirmOrderGroup({
        variables: {
          data: _dataOrderGroup,
          where: {
            id: orderData?.id,
            shop: orderData?.shop?.id,
          },
        },
      });
      if (resConfirm?.data?.confirmOrderGroups?.status) {
        setLastStep(true);
        successFields({ text: "ບັນທຶກສຳເລັດ" });
        window.location.reload();
      } else {
        errorFields({
          text:
            resConfirm?.data?.confirmOrderGroups?.msg ||
            "ບໍ່ສາມາດຢືນຢັນອໍເດີ ກະລຸນາລອງໃໝ່ພາຍຫຼັງ",
        });
      }
    } catch (error) {
      errorFields({ text: "ເກີດຂໍ້ຜິດພາດ" });
      console.log(error);
    }
  };

  // select the bank in dropdown
  const onSelectBankActive = (bank) => {
    setSelectedBank(bank);
  };

  if (addOrderDeliveryLoading) return <LoadingSpinner />;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        gap: 16,
      }}
    >
      {/* ວິທີຈ່າຍເປັນທາງເລືອກທີ່ຕັດກັນ ໃຊ້ tab ຈຶ່ງສື່ວ່າ "ເລືອກໜຶ່ງ" ບໍ່ແມ່ນ "ເຮັດທັງສອງ"
          ຮ້ານທີ່ບໍ່ເປີດ COD ຈະບໍ່ເຫັນ tab ເລີຍ ບໍ່ໃຫ້ມີ tab ດຽວທີ່ກົດບໍ່ໄດ້ */}

      {/* tab ນີ້ຄຸມ "ວິທີໃສ່ທີ່ຢູ່" ຈຶ່ງຕ້ອງອ່ານ isUseLogicstics
          ເມື່ອກ່ອນອ່ານ payMethod (TRANSFER/COD) ຊຶ່ງເປັນ state ຂອງວິທີຈ່າຍເງິນ ຄົນລະເລື່ອງ
          ຜົນຄື payMethod ຕັ້ງຕົ້ນເປັນ "TRANSFER" ຢູ່ແລ້ວ ປຸ່ມຊ້າຍຈຶ່ງໄຮໄລ້ຄ້າງຕະຫຼອດ
          ກົດແລ້ວໄຮໄລ້ບໍ່ຂະຫຍັບ ເບິ່ງຄືກັບວ່າກົດບໍ່ຕິດ ທັງທີ່ເນື້ອຫາຂ້າງລຸ່ມປ່ຽນແລ້ວ */}
      <div className="cf-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={isUseLogicstics === "NOT_USE_LOGICSTIC"}
          className={`cf-tabs__btn${isUseLogicstics === "NOT_USE_LOGICSTIC" ? " cf-tabs__btn--active" : ""}`}
          onClick={() => setIsUseLogicstics("NOT_USE_LOGICSTIC")}
        >
          ພິມທີ່ຢູ່ເອງ
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={isUseLogicstics === "IS_USE_LOGICSTIC"}
          className={`cf-tabs__btn${isUseLogicstics === "IS_USE_LOGICSTIC" ? " cf-tabs__btn--active" : ""}`}
          onClick={() => setIsUseLogicstics("IS_USE_LOGICSTIC")}
        >
          ເລືອກທີ່ຢູ່ຈາກລະບົບ
        </button>
      </div>

      {/* //! FIND ADDRESS BY PHONE
          ໃຊ້ຮ່ວມກັນທັງສອງໂໝດ — ຊື່ກັບເບີຜູ້ຮັບຕ້ອງກອກຢູ່ດີບໍ່ວ່າຈະເລືອກທີ່ຢູ່ຈາກລະບົບ
          ຫຼື ພິມເອງ ເມື່ອກ່ອນມີສອງຊຸດແຍກກັນ ສະຫຼັບ tab ເທື່ອໜຶ່ງກໍຕ້ອງພິມຄືນໃໝ່
          ໂໝດເລືອກຈາກລະບົບຈະໃຊ້ເບີນີ້ໄປຄົ້ນທີ່ຢູ່ໃຫ້ນຳ (ຕອນຄົບ 8 ຕົວ) */}
      <FindAddressByPhone
        // ເບີອາດມາຈາກການຢືນຢັນຄັ້ງກ່ອນ ບໍ່ແມ່ນຈາກອໍເດີ — ບໍ່ດັ່ງນັ້ນຊ່ອງນີ້ວ່າງ ແລະ ກະພິບແດງ
        defaultPhone={phone || orderData?.phone}
        onFound={onFoundAddressByPhone}
        customerName={customerName}
        setCustomerName={setCustomerName}
        setParentPhone={setPhone}
      />

      <div style={{ width: "100%" }}>
        {isUseLogicstics === "IS_USE_LOGICSTIC" ? (
          /**
           * ໂຊຟອມທີ່ຢູ່ໂດຍກົງ
           *
           * ເມື່ອກ່ອນຕ້ອງຜ່ານ 2 ຊັ້ນ: card ລາຍການທີ່ຢູ່ → ກົດ "ເພີ່ມ/ແກ້ໄຂ" → ເປີດໜ້າຕ່າງ
           * ດຽວນີ້ພິມເບີແລ້ວຟອມຂຶ້ນມາເລີຍ ພ້ອມຄ່າ ແຂວງ/ເມືອງ/ສາຂາ ຂອງທີ່ຢູ່ລ່າສຸດເບີນັ້ນ
           *
           * key ສຳຄັນ — Formik ອ່ານ initialValues ເທື່ອດຽວຕອນ mount (ບໍ່ໄດ້ເປີດ
           * enableReinitialize) ຖ້າບໍ່ບັງຄັບໃຫ້ mount ໃໝ່ຕອນຫາທີ່ຢູ່ພົບ ຟອມຈະຄ້າງເປົ່າ
           */
          /* ຫຸ້ມດ້ວຍ .cf-card ໃຫ້ໄດ້ພື້ນຂາວ+ຂອບ ຄືກັບກ່ອງ FindAddressByPhone ດ້ານເທິງ
             ຕົວ FormReceiveAddress ບໍ່ໄດ້ຫຸ້ມ card ໃຫ້ຕົນເອງ — ບ່ອນທີ່ເອີ້ນເປັນຄົນຫຸ້ມ
             (ListReceiveAddress / CardDefaultReceiveAddress / MultiStepForm ກໍ່ຫຸ້ມແບບນີ້) */
          <div className="cf-card">
            <FormReceiveAddress
              key={lastAddressByPhone?.id || "new-address"}
              editData={lastAddressByPhone}
              // ທຸກໃບຂອງເບີນີ້ — ຟອມໃຊ້ຕອນລູກຄ້າສະຫຼັບຂົນສົ່ງ ເພື່ອເອົາທີ່ຢູ່ເກົ່າ
              // ຂອງເຈົ້ານັ້ນຄືນມາໃຫ້ ແທນທີ່ຈະເປັນຊ່ອງເປົ່າ
              savedAddresses={phoneAddresses}
              userConfirm={
                !_.isEmpty(idDataUserConfirm) ? idDataUserConfirm : null
              }
              psid={orderData?.userFbId}
              // ຖາມຢູ່ FindAddressByPhone ດ້ານເທິງແລ້ວ — ສົ່ງລົງໄປໃຫ້ຟອມເຊື່ອງສອງຊ່ອງນັ້ນ
              receiverName={customerName}
              receiverPhone={phone}
              // ຟອມບໍ່ມີປຸ່ມບັນທຶກເອງແລ້ວ — ປຸ່ມ "ຢືນຢັນການຊຳລະ" ຈະເອີ້ນຜ່ານ ref ນີ້
              saveRef={saveAddressRef}
              // ບໍ່ມີໜ້າຕ່າງໃຫ້ປິດແລ້ວ ຟອມຝັງຢູ່ໃນໜ້າເລີຍ
              onCloseModalAdd={noop}
              fetchUserAddressData={refetchAddressByPhone}
              orderData={orderData}
              selectedDelivery={selectedDelivery}
              onUseManualAddress={onUseManualAddress}
            />
          </div>
        ) : (
          <div className="cf-form">
            {isAlert && (
              <div
                className="cf-alert"
                onClick={() => setIsAlert(false)}
                role="alert"
              >
                ກາລຸນາປ້ອນ ເບີໂທ ແລະ ທີ່ຢູ່ປາຍທາງ ໃຫ້ຄົບຖ້ວນ!
              </div>
            )}
            <>
              {/* ຊ່ອງຊື່ກັບເບີຖືກຍ້າຍໄປລວມຢູ່ FindAddressByPhone ດ້ານເທິງແລ້ວ
                  ໃຊ້ຮ່ວມກັນທັງສອງໂໝດ ບ່ອນນີ້ຈຶ່ງເຫຼືອແຕ່ຊ່ອງທີ່ຢູ່ */}
              <div className="cf-field">
                {" "}
                {/* ADDRESS */}
                <label className="cf-field__label" htmlFor="cf-deliveryAddress">
                  ທີ່ຢູ່ຂົນສົ່ງ ພິມຊື່ຂົນສົ່ງ ສາຂາ ໃຫ້ລະອຽດ{" "}
                  <span className="cf-field__required">*</span>
                </label>
                <textarea
                  id="cf-deliveryAddress"
                  // ຂອບແດງກະພິບຈົນກວ່າຈະປ້ອນທີ່ຢູ່
                  className={`cf-input cf-textarea${String(address ?? "").trim() ? "" : " cf-input--attention"}`}
                  value={address}
                  onChange={(e) => setAddress(e?.target?.value)}
                  rows={3}
                  placeholder="ປ້ອນທີ່ຢູ່ລະອຽດ ຫຼື ສາຂາຂົນສົ່ງ..."
                />
              </div>
            </>
          </div>
        )}

        {/* //* PAYMENT */}
      </div>

      {/* ວິທີຈ່າຍເປັນທາງເລືອກທີ່ຕັດກັນ ໃຊ້ tab ຈຶ່ງສື່ວ່າ "ເລືອກໜຶ່ງ" ບໍ່ແມ່ນ "ເຮັດທັງສອງ"
          ໂຜ່ມາຕໍ່ເມື່ອເລືອກທີ່ຢູ່/ຂົນສົ່ງແລ້ວ — ເບິ່ງ isCodAvailable
          ວາງໄວ້ໃຕ້ຟອມທີ່ຢູ່ ເພາະລຳດັບການເຮັດວຽກຄື ໃສ່ທີ່ຢູ່ກ່ອນ ຄ່ອຍເລືອກວິທີຈ່າຍ
          ແລະ tab ນີ້ຈະໂຜ່ຕໍ່ເມື່ອທີ່ຢູ່ພ້ອມແລ້ວ ຢູ່ເທິງຈະເດັ້ງໆດັນເນື້ອຫາລົງ */}
      {isCodAvailable && (
        <div className="cf-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={payMethod === "TRANSFER"}
            className={`cf-tabs__btn${payMethod === "TRANSFER" ? " cf-tabs__btn--active" : ""}`}
            onClick={() => setPayMethod("TRANSFER")}
          >
            ຢືນຢັນການຊຳລະ
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={payMethod === "COD"}
            className={`cf-tabs__btn${payMethod === "COD" ? " cf-tabs__btn--active" : ""}`}
            onClick={() => setPayMethod("COD")}
          >
            ເກັບປາຍທາງ (COD)
          </button>
        </div>
      )}

      {payMethod === "TRANSFER" && (
        <>
          {/* ສະຫຼັບບັນຊີ — ສະແດງສະເພາະຕອນຮ້ານມີຫຼາຍກວ່າ 1 ບັນຊີ */}
          {bankAccountLists?.length > 1 && (
            <div className="cf-field" style={{ width: "100%" }}>
              <label className="cf-field__label" htmlFor="cf-bank-select">
                ບັນຊີທະນາຄານຂອງຮ້ານ
              </label>
              <select
                id="cf-bank-select"
                className="cf-input"
                value={selectedBank?.bankAccount ?? ""}
                onChange={(e) => {
                  const _bank = bankAccountLists.find(
                    (item) => item?.bankAccount === e.target.value,
                  );
                  if (_bank) onSelectBankActive(_bank);
                }}
              >
                {bankAccountLists.map((item, index) => (
                  <option key={index} value={item?.bankAccount}>
                    {item?.bankName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* ລວມ card ຂໍ້ມູນບັນຊີເຂົ້າກັບ card QR — ຊື່ບັນຊີເມື່ອກ່ອນຊ້ຳ 3 ບ່ອນ
              (card ເທິງ, ໃນຮູບ QR, ແລະ ໃຕ້ຮູບ) ເຫຼືອບ່ອນດຽວພໍ */}
          <div className="cf-card cf-qr" style={{ width: "100%" }}>
            <div className="cf-qr__title">ໂອນເງິນຊຳລະຜ່ານ QR</div>
            <div className="cf-qr__subtitle">
              {selectedBank?.bankUser ?? defaultBank?.bankUser}
              {selectedBank?.bankName ? ` · ${selectedBank?.bankName}` : ""}
            </div>
            <img
              className="cf-qr__image"
              src={imageRender(selectedBank?.image)}
              alt={`QR ບັນຊີ ${selectedBank?.bankName ?? ""}`}
            />
            {/* ສອງປຸ່ມແຖວດຽວກັນ ບໍ່ໃຫ້ກິນຄວາມສູງເພີ່ມ */}
            <div className="cf-qr__actions">
              <button
                type="button"
                className="cf-qr__account"
                // ຮ້ານທີ່ຍັງບໍ່ໄດ້ຕັ້ງບັນຊີຈະບໍ່ມີເລກ ປຸ່ມຈຶ່ງເຫຼືອແຕ່ໄອຄອນ — ຕ້ອງມີຊື່ຕິດໄວ້ສະເໝີ
                aria-label="ກັອບປີ້ເລກບັນຊີ"
                onClick={() => onCopy(selectedBank?.bankAccount)}
              >
                <FontAwesomeIcon icon={faCopy} aria-hidden="true" />
                {selectedBank?.bankAccount ?? defaultBank?.bankAccount}
              </button>
              <button
                type="button"
                className="cf-icon-btn"
                aria-label="ດາວໂຫຼດຮູບ QR"
                disabled={isDownloadingQr || !selectedBank?.image}
                onClick={onDownloadQr}
              >
                {isDownloadingQr ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  <FaDownload aria-hidden="true" />
                )}
              </button>
            </div>
            <div className="cf-field__helper">
              ດາວໂຫຼດບໍ່ໄດ້? ກົດຄ້າງທີ່ຮູບ QR ແລ້ວເລືອກ "ບັນທຶກຮູບ"
            </div>
          </div>

          <div className="cf-field" style={{ width: "100%" }}>
            <label className="cf-field__label" htmlFor="file-upload">
              ບ່ອນອັບໂຫຼດສະລີບໂອນເງິນ{" "}
              <span className="cf-field__required">*</span>
            </label>
            <label htmlFor="file-upload" className="cf-upload">
              <input
                type="file"
                id="file-upload"
                accept="image/*"
                onChange={handleUpload}
                hidden
              />
              {isUploadingSlip ? (
                <>
                  <Spinner size="sm" animation="border" />
                  <div className="cf-upload__title">ກຳລັງອັບໂຫຼດຮູບ...</div>
                  <div className="cf-upload__hint">ກະລຸນາລໍຖ້າຄາວໜຶ່ງ</div>
                </>
              ) : file ? (
                <ImageThumb image={file} />
              ) : paySlip ? (
                <img
                  className="cf-upload__preview"
                  alt="ສະລິບໂອນເງິນ"
                  src={imageRender(paySlip)}
                />
              ) : (
                <>
                  <FontAwesomeIcon
                    icon={faFileArrowUp}
                    className="cf-upload__icon"
                  />
                  <div className="cf-upload__title">
                    ບ່ອນອັບໂຫຼດສະລິບໂອນເງິນ
                  </div>
                  <div className="cf-upload__hint">
                    Upload transfer slip here
                  </div>
                </>
              )}
            </label>
            {!isUploadingSlip && paySlip ? (
              <div className="cf-field__helper">ບັນທຶກຮູບແລ້ວ</div>
            ) : null}
          </div>
        </>
      )}

      {payMethod === "COD" && (
        <div className="cf-card mb-2">
          <div className="cf-pay-note">
            ຈ່າຍເງິນສົດໃຫ້ພະນັກງານຂົນສົ່ງຕອນຮັບເຄື່ອງປາຍທາງ ບໍ່ຕ້ອງໂອນລ່ວງໜ້າ
          </div>
        </div>
      )}

      <div className="cf-bottombar">
        <div className="cf-bottombar__total">
          <span className="cf-bottombar__label">ຍອດຕ້ອງຊຳລະ</span>
          <span className="cf-bottombar__amount">
            {numberFormat(orderTotal)}₭
          </span>
        </div>
        {payMethod === "TRANSFER" ? (
          <button
            type="button"
            className="cf-btn cf-btn--primary"
            disabled={isWaitingReceiveAddress}
            onClick={() => {
              _updateOrderGroup();
            }}
          >
            {confirmOrderGroupLoading && (
              <Spinner size="sm" animation="border" />
            )}
            ຢືນຢັນການຊໍາລະ
          </button>
        ) : (
          <button
            type="button"
            className="cf-btn cf-btn--primary"
            disabled={isWaitingReceiveAddress}
            onClick={() => {
              if (_.isEmpty(phone)) {
                return requestionFields({
                  text: "ກະລຸນາ ປ້ອນເບີໂທກ່ອນ!",
                });
              }
              if (_.isEmpty(address)) {
                return requestionFields({
                  text: "ກະລຸນາ ປ້ອນທີ່ຢູ່ເພື່ອຈັດສົ່ງ!",
                });
              }
              setIsShipMentPayType((preOpen) => ({
                ...preOpen,
                isOpenCod: true,
              }));
            }}
          >
            ຢືນຢັນເກັບປາຍທາງ (COD)
          </button>
        )}
      </div>
    </div>
  );
};

export default ShopInfoOrderConfirm;
